<template>
	<div class="flex flex-col">
		<label v-if="label" class="block input-label">{{ label }}</label>
		<select v-bind="$attrs" class="select select-bordered w-full" :disabled="disabled" @input="onChange">
			<option v-for="option in options"
				:value="option.value"
				:disabled="option.disabled"
				:selected="modelValue === option.value || (modelValue === null && option.value === null)"
			>{{ option.label }}</option>
		</select>

		<span v-if="validationError" class="text-red-600 text-xs">
			{{ validationError }}
		</span>
	</div>
</template>


<script lang="ts">

export default {

	inheritAttrs: false,
	emits: ['update:modelValue'],

	props: {
		label: {
			default: 'Label'
		},
		disabled: {
			default: false
		},
		modelValue: {

		},
		options: {
			default: []
		},
		readonly: {
			default: false
		},
		validationError: { type: String }
	},

	methods: {
		onChange(event: Event) {
			const target = event.target as HTMLSelectElement;
			this.$emit('update:modelValue', this.options[target.selectedIndex].value);
		}
	}
}
</script>
